import { render, staticRenderFns } from "./zhangMoZongJie.vue?vue&type=template&id=3f83aff1&scoped=true&"
import script from "./zhangMoZongJie.vue?vue&type=script&lang=js&"
export * from "./zhangMoZongJie.vue?vue&type=script&lang=js&"
import style0 from "./zhangMoZongJie.vue?vue&type=style&index=0&id=3f83aff1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83aff1",
  null
  
)

export default component.exports